export const pageTrackingHeartbeatInterval = 3000;
export const idleInteractionInterval = 15000;
export const topBarHeight = 65;
